import { getIntensityColor } from '@utils/workoutUtils';
import { FeelingValue, ImportProvider, SessionValidation } from '@utils/sessionValidationTypes';

export function providerFromDataSource(dataSource?: SessionValidation['data_source']): ImportProvider | null {
  if (dataSource === 'garmin_import') return 'garmin';
  if (dataSource === 'coros_import') return 'coros';
  return null;
}

export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}h ${m.toString().padStart(2, '0')}min`;
  if (m > 0) return `${m}min ${s.toString().padStart(2, '0')}s`;
  return `${s}s`;
}

export function formatDurationDelta(deltaSeconds: number): string {
  const abs = Math.abs(deltaSeconds);
  const sign = deltaSeconds < 0 ? '-' : '+';
  const h = Math.floor(abs / 3600);
  const m = Math.floor((abs % 3600) / 60);
  const s = abs % 60;
  if (h > 0) return `${sign}${h}h${m > 0 ? ` ${m}min` : ''}`;
  if (m > 0) return `${sign}${m}min${s > 0 ? ` ${s}s` : ''}`;
  return `${sign}${s}s`;
}

export function formatDistance(meters: number, isSwimming: boolean): string {
  if (isSwimming || meters < 1000) return `${Math.round(meters)}m`;
  return `${(meters / 1000).toFixed(2).replace(/\.?0+$/, '')} km`;
}

export function formatDistanceDelta(deltaMeters: number, isSwimming: boolean): string {
  const abs = Math.abs(deltaMeters);
  const sign = deltaMeters > 0 ? '+' : '-';
  if (isSwimming || abs < 1000) return `${sign}${Math.round(abs)}m`;
  return `${sign}${(abs / 1000).toFixed(2).replace(/\.?0+$/, '')}km`;
}

export const FEELINGS:{ value: FeelingValue; emoji: string; label: string }[] = [
  { value: 'tres_difficile', emoji: '🥵', label: 'Très difficile' },
  { value: 'difficile', emoji: '😓', label: 'Difficile' },
  { value: 'moyen', emoji: '😐', label: 'Moyen' },
  { value: 'bien', emoji: '🙂', label: 'Bien' },
  { value: 'excellent', emoji: '😄', label: 'Excellent' },
];

export const SPORT_FIELDS: Record<string, { distance: boolean; pace: boolean; power: boolean }> = {
  running:     { distance: true,  pace: true,  power: false },
  cycling:     { distance: true,  pace: false, power: true  },
  swimming:    { distance: true,  pace: true,  power: false },
  ppg:         { distance: false, pace: false, power: false },
  competition: { distance: true,  pace: false, power: false },
  muscle:      { distance: false, pace: false, power: false },
};

export const RPE_SCALE: {effort: number, color: string}[] = [
  {effort: 1, color: getIntensityColor('Z1')},
  {effort: 2, color: getIntensityColor('Z1')},
  {effort: 3, color: getIntensityColor('Z2')},
  {effort: 4, color: getIntensityColor('Z3')},
  {effort: 5, color: getIntensityColor('Z3')},
  {effort: 6, color: getIntensityColor('Z4')},
  {effort: 7, color: getIntensityColor('Z4')},
  {effort: 8, color: getIntensityColor('Z5')},
  {effort: 9, color: getIntensityColor('Z6')},
  {effort: 10, color: getIntensityColor('Z7')},
];

export const FEELINGS_MAP: Record<FeelingValue, { emoji: string; label: string }> =
  Object.fromEntries(FEELINGS.map(f => [f.value, { emoji: f.emoji, label: f.label }])) as Record<FeelingValue, { emoji: string; label: string }>;
